import { getSessionItem, setSessionItem } from 'utils/storage';
import { SERVER_URL } from 'config/index';

export function getQueryString(params){
    return `?${Object.entries(params).map(e => e.join('=')).join('&') }`
}

export function requestFetch(url, requestOptions, handler, errorHandler) {
    const sessionUser = getSessionItem('loginUser');
    const sessionUserId = sessionUser?.id || null;
    const jToken = getSessionItem('jToken');
    if(sessionUserId != null && sessionUserId !== undefined){
        if( !requestOptions['headers'] ) requestOptions['headers']={}
        if( !requestOptions['headers']['Authorization'] ) requestOptions['headers']['Authorization']=null;
        requestOptions['headers']['Authorization'] = jToken;
    }
    
    //CORS ISSUE 로 인한 조치 - origin 및 credentials 추가 
    // origin 추가
    if (!requestOptions['origin']) {
        requestOptions = { ...requestOptions, origin: SERVER_URL };
    }
    // credentials 추가 
    if (!requestOptions['credentials']) {
        requestOptions = { ...requestOptions, credentials: 'include' };
    }

    fetch(SERVER_URL + url, requestOptions)
        .then(response => {
            return response.json();
        })
        .then((resp) => {
            if (Number(resp.resultCode) === Number(403)) {
                console.log("Login Alert"); //index.jsx라우터파일에 jwtAuthentication 함수로 공통 인증을 사용하는 코드 추가로 alert 원상복구
                setSessionItem('loginUser', {"id":""});
                window.location.href = URL.LOGIN;
                return false;
            } else {
                return resp;
            }
        })
        .then((resp) => {
            if (typeof handler === 'function') {
                handler(resp);
            } else {
                console.log('egov fetch handler not assigned!');
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
            if (error === 'TypeError: Failed to fetch') {
                alert("서버와의 연결이 원활하지 않습니다. 서버를 확인하세요.");
            }

            if (typeof errorHandler === 'function') {
                errorHandler(error);
            } else {
                console.error('egov error handler not assigned!');
                alert("ERR : " + error.message);
            }
        })
        .finally(() => {
            console.log("requestFetch finally end");
        });
}